/**
 * GetUserInformation CrossFrame Listener
 *
 * Handles CrossFrame requests for retrieving user information from the Gateway.
 * User is resolved from the auth token — no input parameters required.
 */

import { getUserInformation } from '@api/userManagement'

/**
 * Get user information for the currently authenticated user.
 */
export async function getUserInformationListener (_message: any): Promise<any> {
    return getUserInformation()
}
